import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import IconButton from '@material-ui/core/IconButton';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import { format, parse } from 'date-fns';
import CloseIcon from "@material-ui/icons/Close";

import { createImageCompeleteUrlWithDate } from '../../../../../utils/parcels';
import { usePaletteScript, withPaletteScript } from '../../../../../adapters/paletteRange';
import { usePaletteAdjustmentsEnabled } from '../../../../../context/PaletteAdjustmentsContext';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: 'transparent',
        width: '100%'
    },
    imageList: {
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
        backgroundColor: 'transparent',
        width: '100%'
    },
    image: {
        height: 140
    },
    imageItem: {
        borderRadius: 5,
        backgroundColor: 'rgba(0,0,0,0.4)'
    },
    titleBar: {
        borderRadius: 5,
        backgroundColor: 'transparent'
    },
    title: {
        color: 'black',
    }
}));

export function renderImageListReducer(state, action) {
    switch (action.type) {
        case 'IMAGE_READY': {
            return state.map((render, index) => {
                if (index === action.payload) return true

                return render
            })
        }
        case 'RESET': {
            return new Array(5).fill(false)
        }
        default:
            return state
    }
}

// One card image: the user's saved palette adjustment for this farm/layer on the card's
// date (only in apps that enable it), so the cards match the main map
function PaletteParcelImage({ className, url, parcel, layer, date }) {
    const paletteEnabled = usePaletteAdjustmentsEnabled();
    const { data: palette, isLoading } = usePaletteScript(
        { parcelId: parcel?.id, layerKey: layer?.key, date },
        { enabled: paletteEnabled }
    );
    if (isLoading) return null;
    return <img className={className} src={withPaletteScript(url, palette)} alt={parcel.properties.name} />;
}

export default function SelectedImagesList({ parcel, imagesDate, selectedIndexLayer, selectedResolution, dispatchRenderImage }) {
    const classes = useStyles();
    const [imageList, setImageList] = React.useState(null);

    React.useEffect(() => {
        if (imagesDate) {

            const images = imagesDate.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.date === value.date
                ))
            ).map((stats, index) => {
                return createImageCompeleteUrlWithDate(parcel, selectedIndexLayer, stats.date, selectedResolution, stats = stats)
            })

            setImageList(images)
        }
    }, [imagesDate])

    const handleChangeImageOnMainMap = (event, image) => {
        event.preventDefault();
    };

    return (
        <ImageList className={classes.imageList} rowHeight={140} gap={10}>

            {imageList?.map((satImage, index) => {

                return (
                    <ImageListItem key={`${satImage.parcelUrl},${satImage.parcel.id}`} key={`${satImage.parcelUrl},${satImage.parcel.id}`}>
                        <Box display="flex" justifyContent="center" className={classes.imageItem}>
                            <PaletteParcelImage
                                className={classes.image}
                                url={satImage.parcelUrl}
                                parcel={parcel}
                                layer={selectedIndexLayer}
                                date={satImage?.stats?.date}
                            />
                        </Box>
                        <ImageListItemBar
                            subtitle={satImage?.stats?.cloud_coverage}
                            position="top"
                            classes={{
                                root: classes.titleBar,
                                title: classes.title,
                                subtitle: classes.title,
                            }}
                            style={{ height: 20 }}
                        />

                        <ImageListItemBar
                            title={format(parse(satImage?.stats?.date, 'yyyy-MM-dd', new Date()), 'LLL d')}
                            subtitle={<span>{satImage?.stats?.basicStats?.mean.toFixed(2)}</span>}
                            classes={{
                                root: classes.titleBar,
                                title: classes.title,
                                subtitle: classes.title,
                            }}
                            actionIcon={
                                <IconButton aria-label={`view in main map ${parcel.properties.name}`} onClick={() => dispatchRenderImage({ type: 'REMOVE', payload: satImage?.stats })}>
                                    <CloseIcon className={classes.title} fontSize='small' color='action' />
                                </IconButton>
                            }
                        />
                    </ImageListItem>
                )
            })}

        </ImageList>
    );
}